import axios from "axios";

export const getAllMarketing = async () => {
  return await axios.get(`${window._HOST}admin/marketing/`, {
    withCredentials: true,
  });
};

export const getAllDetailMarketing = async () => {
  return await axios.get(`${window._HOST}admin/marketing/detail`, {
    withCredentials: true,
  });
};

export const getAllDataTableMarketing = async (
  searchText = null,
  offset = 0,
  limit = 0,
  sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}admin/marketing/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}admin/marketing/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const insertNewMarketing = async (formData) => {
  return await axios.post(`${window._HOST}admin/marketing/`, formData, {
    withCredentials: true,
  });
};

export const updateMarketing = async (formData, id) => {
  return await axios.put(`${window._HOST}admin/marketing/${id}`, formData, {
    withCredentials: true,
  });
};

export const deleteMarketing = async (id) => {
  return await axios.delete(`${window._HOST}admin/marketing/${id}`, {
    withCredentials: true,
  });
};
